import { Field } from 'react-final-form';
import { FileUploadField } from '@unite-us/app-components';

const CustomFileUploadField = ({
  name,
  label,
  id,
  required,
  onFileSelect,
  multiple = false,
  ...rest
}) => {
  return (
    <Field name={name}>
      {(fieldProps) => {
        const { input, meta } = fieldProps;

        const handleFileChange = (files) => {
          let filesToProcess;

          if (Array.isArray(files)) {
            filesToProcess = files.filter(file => file != null);
          } else if (files) {
            filesToProcess = [files];
          } else {
            filesToProcess = [];
          }

          const result = multiple ? filesToProcess : (filesToProcess[0] || null);
          input.onChange(result);

          if (onFileSelect) {
            onFileSelect(filesToProcess);
          }
        };

        return (
          <FileUploadField
            label={label}
            id={id}
            required={required}
            multiple={multiple}
            {...rest}
            {...fieldProps}
            input={input}
            onFilesChange={handleFileChange}
          />
        );
      }}
    </Field>
  );
};

export default CustomFileUploadField;

